import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAutodeskComponent } from './simple-icons-autodesk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAutodeskComponent ],
    exports:      [ SimpleIconsAutodeskComponent ],
    bootstrap:    []
})
export class SimpleIconsAutodeskModule {}
